// CustomDropdown.jsx

import React from "react";

const CustomDropdown = ({
  options = [],
  selectedValue,
  onChange,
  placeholder = "Select",
  className = "",
}) => {
  const selectedOption = options.find(
    (item) => item.value === selectedValue
  );

  return (
    <div className={`dropdown ct_w_100_767 d-flex ${className}`}>
      <button
        className="btn filter-dropdown flex-grow-1 ct_w_100_575 d-flex align-items-center gap-4 justify-content-between text-nowrap"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selectedOption?.label || placeholder}
        <i className="fa-solid fa-angle-down"></i>
      </button>

      <ul className="dropdown-menu ct_custom_dropdown_filter">
        {options.map((item, index) => (
          <li
            key={index}
            className="ct_pointer"
            onClick={() => onChange(item.value, item)}
          >
            <a className="dropdown-item">{item.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomDropdown;